//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminAccountingUsageController_getPlan,
  Response$AdminAccountingUsageController_getPlan$Status$200,
  ResponseContentType$AdminAccountingUsageController_getPlan,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminAccountingUsageController_getPlan = (options: {
  params: Params$AdminAccountingUsageController_getPlan['parameter'];
  config?: QueryOptions<
    Response$AdminAccountingUsageController_getPlan$Status$200[ResponseContentType$AdminAccountingUsageController_getPlan]
  >;
}) =>
  useApiClient<
    Params$AdminAccountingUsageController_getPlan,
    Response$AdminAccountingUsageController_getPlan$Status$200[ResponseContentType$AdminAccountingUsageController_getPlan]
  >({
    method: 'AdminAccountingUsageController_getPlan',
    params: { parameter: options.params },
    config: options.config,
  });
